import { makeStyles } from "@material-ui/styles";

// US Letter portrait (215.9 x 279.4 mm) minus the sheet margin, so the
// offscreen measurement and the printed sheet share one geometry
export const PAGE_MARGIN_MM = 9;
export const PAGE_WIDTH_MM = 215.9 - PAGE_MARGIN_MM * 2;
export const PAGE_HEIGHT_MM = 279.4 - PAGE_MARGIN_MM * 2;
// Margin 0 keeps the browser's header/footer off the sheet (as react-to-print's
// default page style does); the report's `sheet` wrapper supplies the margin,
// since index.css forces body padding to 0 !important
export const PAGE_STYLE = `@page { size: letter portrait; margin: 0; }
@media print { body { -webkit-print-color-adjust: exact; print-color-adjust: exact; } }`;

const dark = "#1F2937";
const gray = "#6B7280";

const quickStatsStyles = makeStyles(() => ({
	// Print only, so the offscreen overflow measurement stays page-content sized
	sheet: {
		"@media print": { padding: `${PAGE_MARGIN_MM}mm` }
	},
	page: {
		width: `${PAGE_WIDTH_MM}mm`,
		fontFamily: "Helvetica, Arial, sans-serif",
		fontSize: "6.5pt",
		color: "#000",
		boxSizing: "border-box"
	},
	title: {
		textAlign: "center",
		fontWeight: "bold",
		fontSize: "12pt"
	},
	meta: {
		textAlign: "center",
		color: "#787878",
		marginBottom: "4pt"
	},
	table: {
		width: "100%",
		borderCollapse: "collapse",
		marginBottom: "4pt",
		pageBreakInside: "avoid",
		"& th, & td": {
			border: "0.5pt solid #BDBDBD",
			padding: "1pt 2pt",
			lineHeight: 1.2,
			textAlign: "left"
		},
		"& th": {
			backgroundColor: dark,
			color: "#fff",
			fontWeight: "bold",
			WebkitPrintColorAdjust: "exact",
			printColorAdjust: "exact"
		}
	},
	center: {
		"& th, & td": { textAlign: "center" }
	},
	firstLeft: {
		"& th:first-child, & td:first-child": {
			textAlign: "left",
			fontWeight: "bold"
		}
	},
	label: {
		width: "34%",
		fontWeight: "bold",
		color: dark
	},
	columns: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "flex-start"
	},
	column: {
		width: "calc(50% - 5pt)"
	},
	playerTable: {
		fontSize: "6pt",
		marginBottom: "3pt",
		"& td:not(:first-child)": { textAlign: "right" }
	},
	columnHead: {
		"& th": {
			backgroundColor: gray,
			fontSize: "5.5pt"
		},
		"& th:not(:first-child)": { textAlign: "right" }
	},
	scoringTable: {
		fontSize: "6pt",
		"& td:not(:first-child), & th:not(:first-child)": {
			textAlign: "center",
			width: "40pt"
		}
	}
}));

export default quickStatsStyles;
